import React from 'react';
import { IconCalendarTime } from '@tabler/icons';
import SimpleLookupCrud from './SimpleLookupCrud';

const PaymentTerms = () => (
    <SimpleLookupCrud
        icon={IconCalendarTime}
        gradient="coral"
        title="Condições de Pagamento"
        subtitle="Ex: à vista, 30/60/90 dias"
        endpoint="payment-terms"
        addLabel="Nova condição"
        columns={[
            { key: 'name', label: 'Nome', type: 'text', required: true },
            { key: 'installments', label: 'Parcelas', type: 'number', default: 1 },
            { key: 'interval_days', label: 'Intervalo (dias)', type: 'number', default: 30 },
            { key: 'is_active', label: 'Ativo', type: 'checkbox', default: true }
        ]}
    />
);

export default PaymentTerms;
